document.addEventListener("DOMContentLoaded", function(){

  //START -- appstle sub_widget subcription option change event
  var bwpFrameEle = document.querySelector('product-form #bwpFrame');
  //When sellingPlanSelected
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
    if(bwpFrameEle){
      bwpFrameEle.classList.add('hidden');
    }
  });
  //When oneTimeSelected
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanRemoved', function() {
    if(bwpFrameEle){
      bwpFrameEle.classList.remove('hidden');
    }
  });
  //END --- appstle sub_widget subcription option change event

  
});



//DOTS ON SECTION
$(document).ready(function () {
  function toggleContent() {
    $('.call--dots--content').not($(this).next('.call--dots--content')).hide();
    $(this).next('.call--dots--content').toggle();
  }

  $('.dots--main_call').hover(
    function () {
      toggleContent.call(this);
    },
    function () {
      // Optional: Add logic for mouse leave if needed
    }
  );

  $('.dots--main_call').click(function () {
    toggleContent.call(this);
  });
});





